module.exports = __webpack_public_path__ + "static/media/bg-04.8313db19.png";